import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/nl-be";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import i18next from "i18next";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(relativeTime);

const dayjsLocaleMap = { nl: "nl-be", en: "en", fr: "fr" };

dayjs.locale(dayjsLocaleMap[i18next.language] ?? "nl-be");
dayjs.tz.setDefault("Europe/Brussels");

i18next.on("languageChanged", (lng) => {
    dayjs.locale(dayjsLocaleMap[lng] ?? "nl-be");
});